import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

export const useGetLast6MonthNewAdvanceData = (): any => {
  const url = `/producer/analytics/getNewAdvancePotential?currentMonth=false`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      last6MonthNewAdvanceWebData: nestedData,
      last6MonthNewAdvanceWebDataLoading: isLoading,
      last6MonthNewAdvanceWebDataError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}

export const useGetCurrentMonthNewAdvanceData = (): any => {
  const url = `/producer/analytics/getNewAdvancePotential?currentMonth=true`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      currentMonthNewAdvanceWebData: nestedData,
      currentMonthNewAdvanceWebDataLoading: isLoading,
      currentMonthNewAdvanceWebDataError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
